import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import DashboardHeader from "../../common/components/DashboardHeader";
import DataGridWithPagination from "../../common/components/DataGridWithPagination";
import { getCall } from "../../services/apiService";


const Drafts = () => {
  const location = useLocation();
  const { programId: paramProgramId } = useParams<{ programId?: string }>();
  const programId = location.state?.programId || paramProgramId;

  const [data, setData] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);
  const [totalData, setTotalData] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState({ value: "", open: false });
  const [searchQuery, setSearchQuery] = useState("");

  const fetchDraftsList = async () => {
    setLoading(true);
    try {
      let url = `registration/drafts?limit=${pageSize}&offset=${(currentPage - 1) * pageSize}`;
      if (programId) url += `&programId=${programId}`;
      if (searchQuery && searchQuery.trim()) {
        url += `&searchText=${encodeURIComponent(searchQuery.trim())}`;
      }
      const res = await getCall(url);
      console.log("anantha", res);
      const rawData = res?.data?.data?.data || [];
      console.log("rawData", rawData);
      const tableHeaders = res?.data?.data?.tableHeaders || [];
      const pagination = res?.data?.data?.pagination || {};
      setData(rawData);
      setColumns(buildDynamicColumns(tableHeaders));
      setTotalData(pagination.totalRecords || 0);
    } catch {
      setData([]);
      setColumns([]);
      setTotalData(0);
    } finally {
      setLoading(false);
    }
  };

  const buildDynamicColumns = (tableHeaders: any[]) => {
    const filteredHeaders = tableHeaders.filter(
      (header: any) =>
        header.key !== "profileUrl" &&
        header.label?.toLowerCase() !== "profile url",
    );

    const widthMap: Record<string, number> = {
      seekerName: 230,
      rmContact: 230,
      gender: 100,
      age: 100,
      location: 120,
      mobileNumber: 180,
      emailAddress: 230,
      numberOfHDBs: 130,
    };

    const cols = filteredHeaders.map((header: any) => ({
      field: header.key,
      headerName: header.label,
      sortable: header.sortable,
      width: widthMap[header.key] !== undefined ? widthMap[header.key] : 130,
      renderCell: (params: any) => {
        const value = params.row[header.key] ?? "-";

        if (["seekerName", "fullName", "name"].includes(header.key)) {
          return (
            <span
              style={{
                width: widthMap[header.key] || 230,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
              title={value}
            >
              <>
                <img
                  src={
                    params.row.profileUrl ||
                    "/assets/images/default-profile.svg"
                  }
                  alt={value}
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginRight: 8,
                    background: "#f0f0f0",
                    border: "1px solid #eee",
                  }}
                />
                <span title={value}>{value}</span>
              </>
            </span>
          );
        }

        return (
          <span
            style={{
              maxWidth: widthMap[header.key] ,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "inline-block",
              verticalAlign: "middle",
              
            }}
            title={typeof value === "string" ? value : ""}
          >
            {value === null || value === undefined || value === ""
              ? "-"
              : value}
          </span>
        );
      },
    }));

    return cols;
  };

  useEffect(() => {
    fetchDraftsList();
    // eslint-disable-next-line
  }, [pageSize, currentPage, searchQuery, programId]);

  return (
    <div>
      <DashboardHeader
        title={` ${totalData} seekers`}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        onSearch={(val) => {
          setSearchQuery(val);
        }}
        onSearchValueChange={(value: string) => {
          setSearchValue((prev) => ({ ...prev, value }));
        }}
      />
      <DataGridWithPagination
        headers={columns}
        seekersData={data}
        totalData={totalData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        loading={loading}
        // isheight={true}
      />
    </div>
  );
};

export default Drafts;